import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "../api/baseurl";
import "react-toastify/dist/ReactToastify.css";
import AdminDashboard from "./admindashboard";
import "./hm-theme.css";

function Notification() {
  const [notification, setNotification] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    const username = JSON.parse(localStorage.getItem("data")).username;
    setLoading(true);
    try {
      const res = await axios.get(
        `/api/notifications/username=${username}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNotification(res.data);
    } catch (error) {
      // silent
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <AdminDashboard />
      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">

          {/* Page Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">notifications</i>
                Notifications
              </h2>
              <p className="hm-page-subtitle">Your recent activity and alerts</p>
            </div>
          </div>

          {/* Notification Card */}
          <div className="hm-card">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">notifications_active</i>
                Recent Notifications
              </h3>
              <span className="badge rounded-pill" style={{ background: "rgba(47,58,136,0.1)", color: "#2f3a88", fontWeight: 600 }}>
                {notification.length} total
              </span>
            </div>
            <div className="hm-card-body p-0">
              {loading ? (
                <div className="hm-empty-state">
                  <i className="material-icons" style={{ animation: "spin 1s linear infinite" }}>refresh</i>
                  <p>Loading notifications...</p>
                </div>
              ) : notification.length === 0 ? (
                <div className="hm-empty-state">
                  <i className="material-icons">notifications_off</i>
                  <p>No notifications yet</p>
                </div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table className="hm-table">
                    <thead>
                      <tr>
                        <th>Subject</th>
                        <th>Message</th>
                        <th>Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {notification.map((n, idx) => (
                        <tr key={idx}>
                          <td>
                            <span className="fw-semibold" style={{ color: "#1e293b" }}>{n.subject}</span>
                          </td>
                          <td>{n.message}</td>
                          <td>
                            <span className="text-muted small">{n.timestamp}</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Notification;
